import { connect } from 'react-redux'
import MetaDashboard from '../index'
import selectors from '../selectors'
import {
  fetchStudents,
  fetchStudentSummary,
  fetchStudentProfile,
  fetchStudentAssessments,
  fetchCorporateData,
  fetchCorporateDepartmentsTable,
  fetchCorporateShortlistTable,
  fetchCorporateCampusQualityTable,
  fetchCorporatePlacementSummary,
  fetchCorporateCompanies,
  fetchInstitutes,
  fetchInstituteSummary,
  fetchInstitutePlacement,
  fetchFilterOptions,
  fetchStudentFilterOptions,
  fetchFilterSkills,
  fetchFilterDepartments,
  fetchFilterDegrees,
  fetchFilterStates,
  fetchFilterColleges,
  fetchFilterCities,
} from '../actions'

const mapStateToProps = state => ({
  students:                selectors.getStudents(state),
  studentsLoading:         selectors.getStudentsLoading(state),
  studentSummary:          selectors.getStudentSummary(state),
  studentProfile:              selectors.getStudentProfile(state),
  studentProfileLoading:       selectors.getStudentProfileLoading(state),
  studentAssessments:          selectors.getStudentAssessments(state),
  studentAssessmentsLoading:   selectors.getStudentAssessmentsLoading(state),

  corporateSummary:        selectors.getCorporateSummary(state),
  corporateGlobalSummary:  selectors.getCorporateGlobalSummary(state),
  corporateDepartments:    selectors.getCorporateDepartments(state),
  corporateDepartmentsTable:        selectors.getCorporateDepartmentsTable(state),
  corporateDepartmentsTableLoading: selectors.getCorporateDepartmentsTableLoading(state),
  corporateShortlist:      selectors.getCorporateShortlist(state),
  corporateShortlistTable:        selectors.getCorporateShortlistTable(state),
  corporateShortlistTableLoading: selectors.getCorporateShortlistTableLoading(state),
  corporateLoading:        selectors.getCorporateLoading(state),
  corporateCampusQuality:       selectors.getCorporateCampusQuality(state),
  corporateCampusQualityTable:        selectors.getCorporateCampusQualityTable(state),
  corporateCampusQualityTableLoading: selectors.getCorporateCampusQualityTableLoading(state),
  corporatePlacementSummary:    selectors.getCorporatePlacementSummary(state),
  corporateCompanies:           selectors.getCorporateCompanies(state),
  corporateCompaniesLoading:    selectors.getCorporateCompaniesLoading(state),

  institutes:              selectors.getInstitutes(state),
  institutesLoading:       selectors.getInstitutesLoading(state),
  instituteSummary:        selectors.getInstituteSummary(state),
  instituteSummaryLoading:      selectors.getInstituteSummaryLoading(state),
  institutePlacement:           selectors.getInstitutePlacement(state),
  institutePlacementLoading:    selectors.getInstitutePlacementLoading(state),

  filterDepartments:       selectors.getFilterDepartments(state),
  filterStates:            selectors.getFilterStates(state),
  filterDegrees:           selectors.getFilterDegrees(state),
  filterColleges:          selectors.getFilterColleges(state),
  filterSkills:            selectors.getFilterSkills(state),
  filterCities:            selectors.getFilterCities(state),
})

const mapDispatchToProps = {
  fetchStudents,
  fetchStudentSummary,
  fetchStudentProfile,
  fetchStudentAssessments,
  fetchCorporateData,
  fetchCorporateDepartmentsTable,
  fetchCorporateShortlistTable,
  fetchCorporateCampusQualityTable,
  fetchCorporatePlacementSummary,
  fetchCorporateCompanies,
  fetchInstitutes,
  fetchInstituteSummary,
  fetchInstitutePlacement,
  fetchFilterOptions,
  fetchStudentFilterOptions,
  fetchFilterSkills,
  fetchFilterDepartments,
  fetchFilterDegrees,
  fetchFilterStates,
  fetchFilterColleges,
  fetchFilterCities,
}

export default connect(mapStateToProps, mapDispatchToProps)(MetaDashboard)
